import { createAction } from 'redux-actions';
export const setStatementAnnotationsFontSize = createAction(
  'STATEMENT_ANNOTATIONS_FONT_SIZE',
);
export const setAnnotationsFontSize =
  ({ fontSize }) =>
  (dispatch) => {
    dispatch(setStatementAnnotationsFontSize({ fontSize }));
  };
